/*
 * Первый запуск: 4-А1, 4-А2, 4-А6.
 *
 * Контрольная ширина — 360, и это не «мобильная версия десктопа»: первый вечер владелец
 * проводит с телефона, сидя в ещё не открывшемся салоне. На широком экране колонка
 * не растягивается, а остаётся колонкой — строка чек-листа во всю ширину монитора
 * читается хуже, а не лучше.
 */

.page {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: var(--bg-workspace);
}

/*
 * ШИРЕ ТЕЛЕФОНА — КАРТОЧКА, И ПРОКРУЧИВАЕТСЯ СТРАНИЦА, А НЕ КОЛОНКА.
 *
 * На телефоне колонка занимает экран целиком и прокручивается сама — так и задумано.
 * На ноутбуке та же раскладка давала форму, приклеенную к верхнему краю окна, со своей
 * внутренней полосой прокрутки: заголовок «Создать салон» упирался в край экрана, а низ
 * формы — в край окна, и человек не понимал, кончилась форма или её обрезало.
 *
 * `margin: auto` вместо выравнивания по центру — чтобы карточка выше экрана не обрезалась
 * сверху (см. screens/auth.module.css, там же объяснение).
 */
@media (min-width: 768px) {
  .page {
    height: auto;
    min-height: 100vh;
    min-height: 100dvh;
    padding: var(--space-6) var(--space-4);
  }

  .column {
    flex: none;
    max-width: 460px;
    padding: var(--space-5);
    margin: auto;
    overflow: visible;
    background: var(--bg-card);
    border: 1px solid var(--border-strong);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-pop);
  }
}

.column {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--space-3);
  width: 100%;
  max-width: 420px;
  min-height: 0;
  padding: var(--space-4);
  margin: 0 auto;
  overflow: auto;
}

.heading {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  line-height: 1.15;
}

.subheading {
  margin: 2px 0 0;
  font-size: var(--font-size-md);
  color: var(--text-secondary);
}

.progressText {
  margin: 4px 0 0;
  font-size: var(--font-size-md);
  line-height: 1.45;
  color: var(--text-brand);
}

.progressTrack {
  height: 6px;
  overflow: hidden;
  background: var(--bg-sunken);
  border-radius: 3px;
}

.progressFill {
  height: 100%;
  background: var(--accent);
  transition: width 0.25s;
}

.groupLabel {
  margin-top: var(--space-1);
  font-size: var(--font-size-xs-plus);
  font-weight: var(--font-weight-semibold);
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

/* Строка чек-листа. 56 px — не «просторнее», а область попадания пальцем. */
.step {
  display: flex;
  gap: var(--space-3);
  align-items: center;
  width: 100%;
  min-height: 56px;
  padding: 10px 12px;
  font: inherit;
  color: inherit;
  text-align: left;
  cursor: pointer;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.stepPending {
  border-color: var(--border-strong);
}

.stepMark {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  font-size: var(--font-size-md);
  font-weight: 700;
  color: var(--text-faint);
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: 50%;
}

.stepMarkDone {
  color: var(--text-on-accent);
  background: var(--accent);
  border-color: var(--accent);
}

.stepBody {
  flex: 1;
  min-width: 0;
}

.stepTitle {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
}

.stepSub {
  font-size: var(--font-size-sm);
  line-height: 1.35;
  color: var(--text-secondary);
}

.stepAction {
  flex: none;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-brand);
}

.optionalStep {
  display: flex;
  gap: var(--space-3);
  align-items: center;
  min-height: 52px;
  padding: 10px 12px;
  border: 1px dashed var(--border-strong);
  border-radius: 12px;
}

.footer {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  max-width: 420px;
  padding: var(--space-2) var(--space-4) 14px;
  margin: 0 auto;
  background: var(--bg-workspace);
  border-top: 1px solid var(--border);
}

.footer button {
  width: 100%;
  height: var(--touch-min-target);
  border-radius: 12px;
}

.missing {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--status-pending-fg);
  text-align: center;
}

/* ─────────── 4-А1 ─────────── */

.field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.fieldLabel {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
}

.control {
  width: 100%;
  height: var(--touch-min-target);
  padding: 8px 11px;
  font-family: var(--font-ui);
  font-size: var(--font-size-lg);
  color: var(--text-primary);
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-md);
}

.control:focus {
  border-color: var(--accent);
  outline: none;
  box-shadow: var(--field-focus-ring);
}

.slugRow {
  display: flex;
  align-items: center;
  height: var(--touch-min-target);
  padding: 0 11px;
  background: var(--bg-card);
  border: 1px solid var(--accent);
  border-radius: var(--radius-md);
  box-shadow: var(--field-focus-ring);
}

.slugInput {
  flex: 1;
  min-width: 0;
  font-family: ui-monospace, Menlo, monospace;
  font-size: var(--font-size-lg);
  color: var(--text-primary);
  background: none;
  border: 0;
}

.slugInput:focus {
  outline: none;
}

.slugSuffix {
  margin-left: auto;
  font-size: var(--font-size-md);
  color: var(--text-secondary);
}

.hint {
  font-size: var(--font-size-sm);
  line-height: 1.45;
  color: var(--text-secondary);
}

.hintOk {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--status-in-progress-fg);
}

.hintError {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--status-no-show-fg);
}

.row2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

/* Два согласия в одной рамке, но разделённые чертой: это два разных документа. */
.consents {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 12px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.consentDivider {
  height: 1px;
  background: var(--grid-line-minor);
}

/* ─────────── 4-А6 ─────────── */

.linkRow {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  height: 52px;
  padding: 0 6px 0 14px;
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: 12px;
}

.linkText {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  font-family: ui-monospace, Menlo, monospace;
  font-size: var(--font-size-base);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qr {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 200px;
  padding: var(--space-3);
  margin: 0 auto;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  text-align: center;
  background: var(--bg-card);
  border: 1px dashed var(--border-strong);
  border-radius: 12px;
}

.pair {
  display: flex;
  gap: var(--space-2);
}

.pair button {
  flex: 1;
  height: var(--touch-min-target);
  border-radius: 12px;
}

.warnPlate {
  padding: 12px 14px;
  font-size: var(--font-size-md);
  line-height: 1.5;
  color: var(--status-pending-fg);
  background: var(--status-pending-bg);
  border-radius: 12px;
}
